export interface RuntimeConfig {
  turnstileSiteKey: string
  clarityProjectId: string
}

/**
 * Public runtime config from the server (Turnstile site key, Clarity id).
 * Failure is non-fatal: the form still works for navigation/validation;
 * the server independently enforces Turnstile on submit.
 */
export async function fetchRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch('/api/config')
    if (!res.ok) throw new Error(`config ${res.status}`)
    const data = (await res.json()) as Partial<RuntimeConfig>
    return {
      turnstileSiteKey: typeof data.turnstileSiteKey === 'string' ? data.turnstileSiteKey : '',
      clarityProjectId: typeof data.clarityProjectId === 'string' ? data.clarityProjectId : '',
    }
  } catch {
    return { turnstileSiteKey: '', clarityProjectId: '' }
  }
}
